import type { FaireProductEntity } from "../../entity_types/product";

export const p_nc5ryb94n2: FaireProductEntity = {
  token: "p_nc5ryb94n2",
  type: "product",
  name: "Game Day Basketball Faux Chenille DTF Heat Transfer",
  brandToken: "b_6up52xmb2z",
  brandName: "Trendy Transfers",
  imageUrl:
    "https://cdn.faire.com/fastly/216cfd48e5eee0a75ac350645a680c94ea9333af6c80664bea13ea0057c0b646.jpeg",
  galleryImageUrls: [],
  priceDollars: 4.56,
  description:
    'DTF Heat Transfer, this can be applied to any combination of polyester/cotton, including 100% cotton.  \n\nHow To Apply:\nDTF FORMULA\nClick Here for Pressing Instructions\n\nADULT\n\n11.5" WIDE OR UP TO 12.75" TALL FOR MORE NARROW DESIGNS\n\nYOUTH\n\n10” WIDE OR UP TO 10.5”TALL FOR MORE NARROW DESIGNS\n\nTODDLER\n\n8” WIDE OR TALL DEPENDING ON DESIGN\n\nINFANT\n\n6” WIDE OR TALL DEPENDING ON DESIGN\n\nLARGE POCKET\n\n5” WIDE OR TALL DEPENDING ON DESIGN\n\nCAN HUGGER\n\n3” WIDE OR TALL DEPENDING ON DESIGN\n\nDue to the many variations in monitors and browsers, colors may appear different on different monitors. Computer monitors are not all calibrated equally and color reproduction on the Internet is not precise.\nWith these factors in mind we cannot guarantee your transfers will match 100% from batch to batch or to the colors you see on your computer monitor. We do our very best to ensure all settings are repeated with each batch but please allow for some variances to occur.',
  tags: [],
  msrpDollars: 5.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:27.318Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
